import { useState } from 'react';
import './Modal.css';

function CreatorModal({ onClose, onSave, token })
{
   const [nom, setNom] = useState('');
   const [nationalite, setNationalite] = useState('');
   const [loading, setLoading] = useState(false);

   const handleSubmit = async (e) =>
   {
      e.preventDefault();
      setLoading(true);

      try
      {
         const response = await fetch(`${process.env.REACT_APP_API_URL}/api/library/creators`, {
            method: 'POST',
            headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
            },
            body: JSON.stringify({ nom, nationalite })
         });

         if (response.ok)
         {
            const newCreator = await response.json();
            onSave(newCreator);
            onClose();
         } else
         {
            alert('Erreur lors de la création');
         }
      } catch (err)
      {
         console.error('Error creating creator:', err);
         alert('Erreur réseau');
      } finally
      {
         setLoading(false);
      }
   };

   return (
      <div className="modal-overlay" onClick={ onClose }>
         <div className="modal-content" onClick={ (e) => e.stopPropagation() }>
            <h3>Créer un nouveau créateur</h3>
            <form onSubmit={ handleSubmit }>
               <div className="form-row">
                  <label>Nom *</label>
                  <input
                     type="text"
                     value={ nom }
                     onChange={ (e) => setNom(e.target.value) }
                     required
                     autoFocus
                  />
               </div>

               <div className="form-row">
                  <label>Nationalité</label>
                  <input
                     type="text"
                     value={ nationalite }
                     onChange={ (e) => setNationalite(e.target.value) }
                  />
               </div>

               <div className="modal-buttons">
                  <button type="button" onClick={ onClose } className="btn-cancel">
                     Annuler
                  </button>
                  <button type="submit" disabled={ loading } className="btn-submit">
                     { loading ? 'Création...' : 'Créer' }
                  </button>
               </div>
            </form>
         </div>
      </div>
   );
}

export default CreatorModal;